module.exports = __webpack_public_path__ + "img/i82.a1e285e0.png";